import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { entityKeys } from "../queryKeys";
import { getEntityBranchById } from "../services/entityBranch.service";

export const useEntityBranch = (branchId: string) => {
  const { i18n } = useTranslation();
  return useQuery({
    queryKey: [...entityKeys.branch(branchId), i18n.language],
    queryFn: () => getEntityBranchById(branchId),
    enabled: !!branchId,
  });
};
